import React from "react";
import Spring from "../springComponent/Spring";

const Servo1 = (props) => {
    const {
        x,
        y,
        angle,
        scale,
        displacement,
        setting1,
        setting2
    } = props;
    const strokeWidth = 0.08;
    const displacementSize = 5;
    const setting1Travel = (setting1/100)*displacementSize;
    const setting2Travel = (setting2/100)*displacementSize;
    const displacementTravel = ((100-displacement)/100)*displacementSize;
    const totalTravel = setting1Travel + setting2Travel + displacementTravel;
    return(
        <g
            transform={`translate(${x}, ${y}) rotate(${angle}) scale(${scale})`}
        >   
            {/**external adjusting piece*/}
            <g
                transform=
                {`translate(${-setting1Travel}, 0)`}
            >
                <path
                    d="
                        M 21,2
                        L 30,2
                        L 30,5.2
                        L 28,5.2
                        L 28,3
                        L 21,3
                        Z
                    "
                    stroke="black"
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                <path
                    d="
                        M 21,12
                        L 30,12
                        L 30,8.8
                        L 28,8.8
                        L 28,11
                        L 21,11
                        Z
                    "
                    stroke="black"
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                <line 
                    x1={21}
                    y1={2.2}
                    x2={30}
                    y2={2.2}
                    stroke="black"
                    strokeWidth={strokeWidth}
                />
                <line 
                    x1={21}
                    y1={11.8}
                    x2={30}
                    y2={11.8}
                    stroke="black"
                    strokeWidth={strokeWidth}
                />
                <line 
                    x1={28}
                    y1={5}
                    x2={30}
                    y2={5}
                    stroke="black"
                    strokeWidth={strokeWidth}
                />
                <line 
                    x1={28}
                    y1={9}
                    x2={30}
                    y2={9}
                    stroke="black"
                    strokeWidth={strokeWidth}
                />
                <Spring 
                    x={28}
                    y={3.2}
                    angle={90}
                    scale={1}
                    width={7.6}
                    length={15-displacementTravel-setting1Travel}
                    girth={5}
                    color="black"
                    coils={5}
                    strokeWidth={strokeWidth}
                    innerLines={true}
                />
                {/**internal adjusting piece*/}
                <g
                    transform=
                    {`translate(${-setting2Travel}, 0)`}
                >  
                    <Spring 
                        x={28}
                        y={9}
                        angle={90}
                        scale={"-1,1"}
                        width={4}
                        length={
                            totalTravel <= displacementSize ? 9 :
                            (9 - (totalTravel-displacementSize))
                        }
                        girth={7}
                        color="black"
                        coils={5}
                        strokeWidth={strokeWidth}
                        innerLines={true}
                    />
                    <path
                        d="
                            M 28,5.2
                            L 35,5.2
                            L 35,8.8
                            L 28,8.8
                            L 28,7.8
                            L 27,7.8
                            L 27,6.2
                            L 28,6.2
                            Z
                        "
                        stroke="black"
                        strokeWidth={strokeWidth}
                        fill="white"
                    />
                    <path
                        d="
                            M 28,5.2
                            L 28,5
                            L 35,5
                            L 35,9
                            L 28,9
                            L 28,8.8
                        "
                        stroke="black"
                        strokeWidth={strokeWidth}
                        fill="none"
                    />
                </g>
            </g>
            <path
                d="
                    M 22,0
                    L 25,0
                    L 25,2.2
                    L 22,2.2
                    Z
                "
                stroke="black"
                strokeWidth={strokeWidth}
                fill="black"
                fillOpacity={0.3}
            />
            <path
                d="
                    M 22,11.8
                    L 25,11.8
                    L 25,14
                    L 22,14
                    Z
                "
                stroke="black"
                strokeWidth={strokeWidth}
                fill="black"
                fillOpacity={0.3}
            />
            {/**displacement piece*/}
            <g
                transform=
                {`translate(${displacementTravel}, 0)`}
            >
                <path
                    d="
                        M 1,3
                        L 12,3
                        L 12,6
                        A 1,1 0,1,1 12,8
                        L 12,11
                        L 1,11
                        A 3,3 0,0,1 1,7
                        A 3,3 0,0,0 1,3
                    "
                    stroke="black"
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                <path
                    d="
                        M 12,6
                        A 1,1 0,1,1 12,8
                        L 9,8
                        L 9,7.8
                        L 6,7.8
                        L 6,7.5
                        L 3,7.5
                        L 2.5,7
                        L 3,6.5
                        L 6,6.5
                        L 6,6.2
                        L 9,6.2
                        L 9,6
                        Z
                    "
                    stroke="black"
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                <path
                    d="
                        M 12.2,3
                        L 13,3
                        L 13,4.2
                        L 14,4.2
                        L 14,6.2
                        L 15,6.2
                        L 15,7.8
                        L 14,7.8
                        L 14,9.8
                        L 13,9.8
                        L 13,11
                        L 12.2,11
                        L 12.2,8.2
                        A 1.22,1.22 0,0,0 12.2,5.8
                        Z
                    "
                    stroke="black"
                    strokeWidth={strokeWidth}
                    fill="white"
                />
            </g>
        </g>
    );
}

export default Servo1;
